import React from 'react';
import { AlertTriangle, X, Shield } from 'lucide-react';

const MessageWarning = ({ violations, onDismiss, severity = 'high' }) => {
    if (!violations || violations.length === 0) return null;

    const getConfig = () => {
        switch (severity) {
            case 'critical':
                return {
                    bg: 'bg-red-50',
                    border: 'border-red-200',
                    text: 'text-red-800',
                    icon: 'text-red-600',
                    title: 'Message Blocked'
                };
            case 'high':
                return {
                    bg: 'bg-yellow-50',
                    border: 'border-yellow-200',
                    text: 'text-yellow-800',
                    icon: 'text-yellow-600',
                    title: 'Warning'
                };
            default:
                return {
                    bg: 'bg-blue-50',
                    border: 'border-blue-200',
                    text: 'text-blue-800',
                    icon: 'text-blue-600',
                    title: 'Notice'
                };
        }
    };

    const config = getConfig();

    return (
        <div className={`${config.bg} ${config.border} border rounded-lg p-3 mb-3`}>
            <div className="flex items-start">
                <AlertTriangle className={`w-5 h-5 ${config.icon} mt-0.5 flex-shrink-0`} />
                <div className="ml-3 flex-1">
                    <h4 className={`text-sm font-semibold ${config.text}`}>{config.title}</h4>
                    <p className={`text-sm ${config.text} mt-1`}>
                        {severity === 'critical'
                            ? 'Your message contains contact information or attempts to bypass the platform. This is against our Terms of Service.'
                            : 'Your message may contain restricted content. Please review before sending.'}
                    </p>
                    <ul className="mt-2 space-y-1">
                        {violations.slice(0, 3).map((v, idx) => (
                            <li key={idx} className={`text-xs ${config.text} flex items-center`}>
                                <span className="w-1.5 h-1.5 rounded-full bg-current mr-2"></span>
                                {v.message || `Detected ${v.type}`}
                            </li>
                        ))}
                    </ul>
                </div>
                {onDismiss && (
                    <button onClick={onDismiss} className={`${config.text} hover:opacity-70 ml-2`}>
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default MessageWarning;
